module.exports = __webpack_public_path__ + "img/qrcode_logo.e3577b9c.png";